import React from 'react';

import './product-preview.scss';

const ProductPreview = ({ data, reversed }) => {
	const productData = typeof data.product_preview === "string"
		? JSON.parse(data.product_preview)
		: data.product_preview;

	return (
		<div className={`product-preview ${reversed ? 'reversed' : ''}`}>
			<h2 className="preview-header">Top 3 Products By Revenue</h2>
			{productData.map((item, i) => {
				return (
					<div key={i} className="preview">
						{`${item.brand} | ${item.product_name}`}
					</div>
				);
			})}
		</div>
	);
};

export default ProductPreview;
